// extracted by mini-css-extract-plugin
module.exports = {"content":"EmptyTexte_content__1rhO3"};